import styled from "styled-components";

export const UnitWrapper = styled.div`
    background-color: #ededed;
    padding: 45px;
    .unitBox {
        width: 1000px;
        margin: 0 auto;
        background-color: #6464cd;
        padding: 5px;
        .unitCon {
            background-color: white;
            padding: 30px;
        }
        dl {
            overflow: hidden;
            margin-bottom: 15px;
            dt {
                font-size: 18px;
                line-height: 50px;
                margin-right: 10px;
                color: #5c5c5c;
                white-space: nowrap;
                float: left;
            }
            dd {
                display: flex;
                flex-wrap: wrap;
                img {
                    display: inline-block;
                    margin: 10px;
                }
            }
        }
    }
    @media screen and (max-width: 750px) {
        padding: 15px;
        .unitBox {
            width: 100%;
            .unitCon {
                padding: 10px;
                .ant-col-12 {
                    flex: 100%;
                    max-width: 100%;
                }
                dl {
                    margin-bottom: 0px;
                    dt {
                        font-size: 14px;
                    }
                    dd img {
                        display: block;
                    }
                }
            }
        }
    }
`;
